import * as Sentry from '@sentry/react';

import { trackAnalyticsEvent } from '~/common/analytics/analyticsClient';
import { isDev } from '~/dev/utils/isDev';

type SidebarNavPreferenceAction = 'opt_in' | 'opt_out';

const ANALYTICS_EVENTS: Record<SidebarNavPreferenceAction, string> = {
  opt_in: 'sidebar_navigation_onboarded',
  opt_out: 'sidebar_navigation_offboarded',
};

const METRIC_NAMES: Record<SidebarNavPreferenceAction, string> = {
  opt_in: 'ui.sidebar_nav.opt_in',
  opt_out: 'ui.sidebar_nav.opt_out',
};

const VARIANT_TRANSITIONS: Record<
  SidebarNavPreferenceAction,
  { previous_variant: string; variant: string }
> = {
  opt_in: {
    previous_variant: 'legacy-nav',
    variant: 'side-nav',
  },
  opt_out: {
    previous_variant: 'side-nav',
    variant: 'legacy-nav',
  },
};

export const recordSidebarNavPreferenceMetric = (
  action: SidebarNavPreferenceAction,
) => {
  trackAnalyticsEvent(ANALYTICS_EVENTS[action], VARIANT_TRANSITIONS[action]);

  if (isDev) {
    console.info(`[sidebar-nav metric] ${action}`);
    return;
  }

  Sentry.startInactiveSpan({
    name: METRIC_NAMES[action],
    op: 'metric.counter',
    attributes: {
      'sentry.op': 'metric.counter',
      'sentry.origin': 'manual.react.metrics',
      value: 1,
      metric_type: 'custom_counter',
      sidebar_nav_action: action,
    },
  }).end();
};
